// 假数据配置
export const mockVisualData = {
  statistics: {
    totalSpaces: 156,
    occupiedSpaces: 98,
    availableSpaces: 58,
    utilizationRate: 62.8
  },
  floors: [
    { id: '1', name: '1楼', spaces: 25, occupied: 18, available: 7 },
    { id: '2', name: '2楼', spaces: 30, occupied: 22, available: 8 },
    { id: '3', name: '3楼', spaces: 28, occupied: 20, available: 8 },
    { id: '4', name: '4楼', spaces: 32, occupied: 25, available: 7 },
    { id: '5', name: '5楼', spaces: 41, occupied: 13, available: 28 }
  ],
  spaceTypes: [
    { type: '办公区', count: 45, color: '#1890ff' },
    { type: '会议室', count: 23, color: '#52c41a' },
    { type: '休息区', count: 15, color: '#faad14' },
    { type: '存储区', count: 12, color: '#722ed1' },
    { type: '其他', count: 61, color: '#f5222d' }
  ]
};
